// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__1fybi","buttons":"SendReceipts_buttons__1L2ib","email":"SendReceipts_email__2x-fq","bookApptTitle":"SendReceipts_bookApptTitle__-XnDJ"};